import React, { useState, useEffect } from "react";
import PersonaReact from 'persona-react';

import { LeadService } from '../../_services';

const Persona = (props) => {
    const { leadId, onInquiryStatusUpdate } = props;
    const [inquirySession, setInquirySession] = useState(null);

    const onComplete = args => {
        const { inquiryId, status, fields } = args;
        
        if (onInquiryStatusUpdate)
            onInquiryStatusUpdate(status.toLowerCase());
    }

    useEffect(() => {
        (async () => {
            if (leadId) {
                let inq = await LeadService.getLeadPersonaInquirySession(leadId);

                if (inq.data) {
                    setInquirySession(inq.data);
                }

            } else {
                setInquirySession(null);
            }
        })();
    }, [leadId])

    if (!inquirySession)
        return <p>Loading...</p>

    return (
        <div id='persona-container'>
            <PersonaReact
                inquiryId={inquirySession.inquiryId}
                sessionToken={inquirySession.sessionToken}
                environment={inquirySession.environment}
                onComplete={onComplete}
                //onReady={(a) => console.dir(a) }
                ///onCancel={({ inquiryId, sessionToken }) => console.log('onCancel')}
                //onError={(error) => console.log(error)}
            />
        </div>
    )
}

export default Persona;